var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"documents__list"},_vm._l((_vm.documents),function(doc,i){return _c('DocumentRow',{key:doc.link,attrs:{"index":i,"document":doc,"details-text":_vm.detailsType == 'created_by'
        ? `${doc.created_by_name.value} добавил(а)
        ${doc.active_date ? doc.active_date.value : ''}`
        : _vm.detailsType == 'size'
        ? _vm.fileSize(doc)
        : '',"document-name":doc.filename.value,"allow-remove":_vm.allowRemove ? _vm.allowRemove : _vm.userId === doc.created_by.value},on:{"delete-file":_vm.deleteFile}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }